<template>
	<router-view>
	</router-view>
</template>

<script>
	export default {
		name: "NotificationGroupsView",
	};

</script>

<style scoped>

</style>
